import axios from "axios";
import {
  setCustomerProfileLoading,
  setCustomerProfile,
  setCustomerProfileError,
  updateCustomerUser,
  updateCstPack,
} from "./reducer";

export const fetchCustomerProfile = () => async (dispatch: any) => {
  const userRole = localStorage.getItem("userole_");
  if (userRole !== "cst") return;

  try {
    dispatch(setCustomerProfileLoading());
    const response = await axios.post("accounts/get_customer", {}, { withCredentials: true });
    if (response.status === "SENT" && response.userprofile) {
      dispatch(setCustomerProfile(response.userprofile));
      localStorage.setItem("cstpack", JSON.stringify(response.userprofile.cstpack || {}));
    }
  } catch (error: any) {
    if (error.response?.status === 403) {
      dispatch(setCustomerProfileError("Session expired!"));
    } else {
      dispatch(setCustomerProfileError(error.response?.data?.error || "An error occurred"));
      console.error("Error fetching customer profile:", error);
    }
  }
};

export const updateCustomerUserAction = (userData: any) => (dispatch: any) => {
  dispatch(updateCustomerUser(userData));
  localStorage.setItem("userdata", JSON.stringify(userData));
  localStorage.setItem("user_", userData.email);
};

export const updateCstPackAction = (packData: any) => (dispatch: any) => {
  dispatch(updateCstPack(packData));
  localStorage.setItem("cstpack", JSON.stringify(packData));
};
